export const CAMPAIGN_HEADER = 'https://res.cloudinary.com/dhiwlvpg7/image/upload/v1696257029/home/campaign-header.jpg';